<section class="signup-container" [class.height-sidebar-content]="!hasGlobalMessages()"
  [class.height-sidebar-content-global-message]="hasGlobalMessages()">
  <div class="signup" id="scroll-to-top-ref">

    <div class="signup__header animated fadeInDown">
      <div class="container my-3">
        <a routerLink="/shop">
          <img class="signup__logo" src="/assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Philly Foodworks">
        </a>
      </div>
    </div>

    @if (isLoadingContent() || accountService.isLoading()) {
    <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
    }

    <div class="row alert alert-success border-0 fade show animated fadeInUp rounded-0 text-center mb-0" role="alert">
      <div class="d-flex justify-content-center align-items-center gap-3">
        50% off the best food in the city and your supporting local producers, don't think so hard and
        just get a box!
        <section class="d-none d-lg-block">
          <svg width="20px" height="20px" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7 0.75C7.98438 0.75 8.85938 1.32422 9.29688 2.17188C10.1992 1.87109 11.2383 2.08984 11.9492 2.80078C12.6602 3.51172 12.8789 4.55078 12.5781 5.45312C13.4258 5.89062 14 6.76562 14 7.75C14 8.76172 13.4258 9.63672 12.5781 10.0742C12.8789 10.9766 12.6602 11.9883 11.9492 12.6992C11.2383 13.4102 10.1992 13.6289 9.29688 13.3555C8.85938 14.2031 7.98438 14.75 7 14.75C5.98828 14.75 5.11328 14.2031 4.67578 13.3555C3.77344 13.6289 2.76172 13.4102 2.05078 12.6992C1.33984 11.9883 1.12109 10.9766 1.39453 10.0742C0.546875 9.63672 0 8.76172 0 7.75C0 6.76562 0.546875 5.89062 1.39453 5.45312C1.12109 4.55078 1.33984 3.51172 2.05078 2.80078C2.76172 2.08984 3.77344 1.87109 4.67578 2.17188C5.11328 1.32422 5.98828 0.75 7 0.75ZM7.57422 4.85156C7.57422 4.55078 7.32812 4.30469 7 4.30469C6.69922 4.30469 6.45312 4.55078 6.45312 4.85156V5.07031C6.28906 5.125 6.09766 5.15234 5.93359 5.23438C5.49609 5.42578 5.11328 5.80859 5.03125 6.32812C4.97656 6.62891 5.00391 6.92969 5.14062 7.17578C5.25 7.44922 5.44141 7.61328 5.63281 7.75C5.98828 7.99609 6.42578 8.13281 6.80859 8.24219H6.86328C7.27344 8.37891 7.57422 8.48828 7.76562 8.625C7.84766 8.67969 7.875 8.73438 7.90234 8.76172C7.92969 8.78906 7.92969 8.87109 7.90234 9.00781C7.90234 9.11719 7.82031 9.22656 7.62891 9.30859C7.4375 9.39062 7.10938 9.44531 6.72656 9.36328C6.53516 9.33594 6.20703 9.22656 5.90625 9.11719C5.85156 9.11719 5.79688 9.08984 5.71484 9.0625C5.44141 8.98047 5.14062 9.11719 5.03125 9.41797C4.94922 9.69141 5.08594 10.0195 5.38672 10.1016C5.41406 10.1289 5.46875 10.1289 5.52344 10.1562C5.76953 10.2383 6.17969 10.375 6.45312 10.4297V10.6758C6.45312 10.9766 6.69922 11.2227 7 11.2227C7.32812 11.2227 7.57422 10.9766 7.57422 10.6758V10.457C7.73828 10.4297 7.90234 10.375 8.06641 10.3203C8.53125 10.1289 8.88672 9.74609 8.99609 9.17188C9.05078 8.87109 9.02344 8.59766 8.91406 8.32422C8.80469 8.05078 8.61328 7.85938 8.42188 7.72266C8.03906 7.47656 7.57422 7.3125 7.19141 7.20312H7.16406C6.75391 7.06641 6.45312 6.98438 6.26172 6.84766C6.15234 6.79297 6.125 6.73828 6.125 6.71094C6.09766 6.68359 6.09766 6.62891 6.09766 6.51953C6.125 6.4375 6.17969 6.32812 6.39844 6.24609C6.58984 6.13672 6.91797 6.10938 7.30078 6.16406C7.4375 6.19141 7.84766 6.24609 7.95703 6.30078C8.25781 6.35547 8.55859 6.19141 8.64062 5.89062C8.72266 5.61719 8.53125 5.31641 8.25781 5.23438C8.09375 5.20703 7.76562 5.125 7.57422 5.09766V4.85156Z"
              fill="black" />
          </svg>
        </section>
      </div>
    </div>

    <div class="signup__body animated fadeInUp">
      <h1 class="signup__head-text">Set Up Your New Account</h1>
      <div class="container">
        <mat-stepper [linear]="true" #stepper class="animated fadeIn" [disableRipple]="true">


          <mat-step #firstStep [completed]="(
              this.hasDeliveryAddressCoverage() &&
              !!this.selectedDeliveryDay()) &&
              (
                (
                  this.selectedDeliveryDay()?.allowTimeWindow &&
                  !!this.selectedDeliveryTimeWindow()
                ) ||
                !this.selectedDeliveryDay()?.allowTimeWindow
              )" [editable]="false" label="Delivery Address">
            <ng-template matStepperIcon="edit">
              1
            </ng-template>
            <div>
              <form>

                <app-check-address-signup (out_deliveryAddress)="this.deliveryAddress.set($event)"
                  (out_hasDeliveryAddressCoverage)="this.hasDeliveryAddressCoverage.set($event)"
                  (out_isGoogleAddressFilled)="this.isGoogleAddressFilled.set($event)"
                  [isCheckContinue]="isCheckContinue()">
                </app-check-address-signup>

                <!-- TODO: Review hydratation error when using "@if" to avoid the rendering of this div -->
                @if (isGoogleAddressFilled() && hasDeliveryAddressCoverage()) {
                <div class="row form-row animated fadeInDown">
                  <div class="col-md-6">
                    <h6 class="signup__sub-head-text">When should we deliver your order?</h6>
                    <mat-form-field class="w-100" [class.option-selected]="!!selectedDeliveryDay()">
                      <mat-label>* Choose a day</mat-label>
                      <mat-select name="selectedDeliveryDay" [value]="selectedDeliveryDay()?.id || null"
                        (selectionChange)="setSelectedDeliveryDay($event)">
                        @for (item of deliveryOptions; track $index) {
                        <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (isCheckContinue() && !selectedDeliveryDay()) {
                    <div class="invalid-feedback d-block">
                      <i class="fas fa-xmark"></i>
                      This field is required
                    </div>
                    }
                  </div>
                  <div class="col-md-6 d-flex align-items-end">
                    @if (selectedDeliveryDay()) {
                    @if (selectedDeliveryDay()?.allowTimeWindow) {
                    <mat-form-field class="w-100 animated fadeInLeft"
                      [class.option-selected]="!!selectedDeliveryTimeWindow()">
                      <mat-label>* Choose a time window</mat-label>
                      <mat-select name="selectedDeliveryTimeWindow" [value]="selectedDeliveryTimeWindow() || null"
                        (selectionChange)="selectedDeliveryTimeWindow.set($event.value)">
                        @for (item of timeSet(); track $index) {
                        <mat-option [value]="item.id">{{ item.name }}</mat-option>
                        }
                      </mat-select>
                      @if (isCheckContinue() && !selectedDeliveryTimeWindow()) {
                      <div class="invalid-feedback d-block">
                        <i class="fas fa-xmark"></i>
                        This field is required
                      </div>
                      }
                    </mat-form-field>
                    } @else {
                    <mat-form-field class="w-100 animated fadeInLeft">
                      <mat-label>Time window</mat-label>
                      <input type="text" matInput readonly="true" name="selectedDeliveryTimeWindow"
                        [value]="selectedDeliveryDay()?.timeSet?.[0]?.name">
                    </mat-form-field>
                    }
                    }
                  </div>
                </div>

                <div class="form-row-action ">
                  <button type="button" (click)="validateDeliveryAddress()" class="btn btn-primary animated fadeIn">
                    Continue
                  </button>
                </div>
                }
              </form>
            </div>
          </mat-step>

          <mat-step #secondStep [completed]="isValidFormPersonalInformation() && firstStep.completed" [editable]="false"
            label="Personal Information">
            @if (!!personalInformation()) {
            <div class="container animated fadeIn">
              <form class="needs-validation">

                <div class="row form-row mt-5">
                  <!-- First Name -->
                  <div class="col-md-4">
                    <div class="form-floating has-validation">
                      <input placeholder type="text" class="form-control"
                        [class.is-invalid]="!personalInformationValidations.get('firstName')?.()?.valid"
                        name="firstNameCtrl" [ngModel]="personalInformation()?.firstName"
                        (blur)="validatePersonalInfoField('firstName', $event)"
                        (ngModelChange)="updatePersonalInformation({firstName: $event }, 'firstName')" />
                      <label for="firstNameCtrl">* First Name</label>
                      @if (!personalInformationValidations.get('firstName')?.()?.valid) {
                      @for (error of personalInformationValidations.get('firstName')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  <!-- Last Name -->
                  <div class="col-md-4">
                    <div class="form-floating">
                      <input placeholder type="text" class="form-control" name="lastNameCtrl"
                        [class.is-invalid]="!personalInformationValidations.get('lastName')?.()?.valid"
                        [ngModel]="personalInformation()?.lastName"
                        (blur)="validatePersonalInfoField('lastName', $event)"
                        (ngModelChange)="updatePersonalInformation({lastName: $event }, 'lastName')" />
                      <label for="lastNameCtrl">* Last Name</label>
                      @if (!personalInformationValidations.get('lastName')?.()?.valid) {
                      @for (error of personalInformationValidations.get('lastName')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  <!-- Phone -->
                  <div class="col-md-4">
                    <div class="form-floating">
                      <input placeholder type="text" class="form-control" maxlength="10" name="phoneCtrl" appOnlyNumber
                        [class.is-invalid]="!personalInformationValidations.get('phone')?.()?.valid"
                        [ngModel]="personalInformation()?.phone" (blur)="validatePersonalInfoField('phone', $event)"
                        (ngModelChange)="updatePersonalInformation({phone: $event }, 'phone')" />
                      <label for="phoneCtrl">* Phone</label>
                      @if (!personalInformationValidations.get('phone')?.()?.valid) {
                      @for (error of personalInformationValidations.get('phone')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                </div>

                <div class="row form-row">
                  <!-- Email -->
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input placeholder type="email" class="form-control" name="emailCtrl"
                        [class.is-invalid]="!personalInformationValidations.get('email')?.()?.valid"
                        [ngModel]="personalInformation()?.email" (blur)="validatePersonalInfoField('email', $event)"
                        (ngModelChange)="updatePersonalInformation({email: $event }, 'email')" />
                      <label for="emailCtrl">* Email</label>
                      @if (!personalInformationValidations.get('email')?.()?.valid) {
                      @for (error of personalInformationValidations.get('email')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  <!-- Password -->
                  <div class="col-md-6">
                    <div class="form-floating has-validation">
                      <mat-form-field subscriptSizing="dynamic" class="w-100">
                        <mat-label>* Password</mat-label>
                        <input placeholder type="password" class="form-control form-control-password" matInput
                          maxlength="30" name="passwordCtrl" [class.is-invalid]="!isPasswordValid1()"
                          [ngModel]="personalInformation()?.password" (ngModelChange)="
                            updatePersonalInformation({ password: $event }, 'password')
                          " type="{{ hidePassword ? 'password' : 'text' }}" />
                        <button mat-button matSuffix type="button" (click)="hidePassword = !hidePassword"
                          class="eye-icon-button"
                          [attr.aria-label]="'Toggle ' + (hidePassword ? 'visibility' : 'hide')">
                          @if (hidePassword) {
                          <span class="material-symbols-outlined text-muted">
                            visibility
                          </span>
                          } @else {
                          <span class="material-symbols-outlined text-muted">
                            visibility_off
                          </span>
                          }
                        </button>
                      </mat-form-field>

                      <div class="d-flex row row-cols-2" [ngClass]="
                          isPasswordValid1() ? 'valid-feedback' : 'invalid-feedback'
                        ">
                        @for (condition of passwordConditions; track condition) {
                        <div class="col" [ngClass]="condition.valid() ? 'text-success' : 'text-danger'">
                          <i class="fas" [ngClass]="condition.valid() ? 'fa-check' : 'fa-xmark'"></i>
                          {{ condition.label }}
                        </div>
                        }
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row form-row">
                  <!-- How did you hear about us? -->
                  <div class="col-md-6 {{ selectedReferralSourceInfo()?.hasAdditionalInfo ? 'pb-5' : ''}}">
                    <mat-form-field class="w-100"
                      [class.is-invalid]="!personalInformationValidations.get('referralSource')?.()?.valid">
                      <mat-label>* How did you hear about us?</mat-label>
                      <mat-select [(value)]="selectedReferralSource" (openedChange)="onSelectReferralSource()"
                        (selectionChange)="updatePersonalInformation({referralSource: $event.value?.toString()}, 'referralSource')">
                        @for (source of referralSource; track $index) {
                        <mat-option [value]="source.id">{{ source.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (!personalInformationValidations.get('referralSource')?.()?.valid) {
                    @for (error of personalInformationValidations.get('referralSource')?.()?.error; track $index) {
                    <div class="invalid-feedback">
                      <i class="fas fa-xmark"></i>
                      {{error}}
                    </div>
                    }
                    }
                  </div>

                  @if (selectedReferralSourceInfo()?.hasAdditionalInfo) {
                  <div class="col-md-6 animated fadeIn">
                    <div class="form-floating">
                      <input placeholder type="text" class="form-control" name="advertisementCtrl"
                        [class.is-invalid]="!personalInformationValidations.get('additionalInfo')?.()?.valid"
                        [ngModel]="personalInformation()?.additionalInfo"
                        (blur)="validatePersonalInfoField('additionalInfo', $event)"
                        (ngModelChange)="updatePersonalInformation({additionalInfo: $event }, 'additionalInfo')" />
                      <label for="advertisementCtrl">* Tell us more - where did you find us?</label>
                      @if (!personalInformationValidations.get('additionalInfo')?.()?.valid) {
                      @for (error of personalInformationValidations.get('additionalInfo')?.()?.error; track $index) {
                      <div class="invalid-feedback">
                        <i class="fas fa-xmark"></i>
                        {{error}}
                      </div>
                      }
                      }
                    </div>
                  </div>
                  }
                </div>
                <div class="row form-row">
                  <div class="col-12 mt-3 mb-2 pt-3">
                    <mat-slide-toggle [(ngModel)]="isCheckedAddAnotherContact" name="isCheckedAddAnotherContact"
                      (change)="anotherAccountSlideChanged($event.checked)"> I
                      want to add another contact person to my account
                    </mat-slide-toggle>
                    <ng-container *ngIf="isCheckedAddAnotherContact()">
                      <div class="row row-cols-2 mt-3 pt-3 animated fadeIn">
                        <div class="col mb-2">
                          <div class="form-floating">
                            <input placeholder type="text" class="form-control" name="firstNameContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactFirstName')?.()?.valid"
                              [ngModel]="personalInformation()?.contactPerson?.firstName"
                              (blur)="validatePersonalInfoField('contactFirstName', $event)"
                              (ngModelChange)="updatePersonalInformation({ firstName: $event }, 'contactFirstName', true)" />
                            <label for="firstNameContactCtrl">First Name</label>
                            @if (!personalInformationValidations.get('contactFirstName')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactFirstName')?.()?.error; track
                            $index) {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                        <div class="col mb-2">
                          <div class="form-floating">
                            <input placeholder type="text" class="form-control" name="lastNameContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactLastName')?.()?.valid"
                              [ngModel]="personalInformation()?.contactPerson?.lastName"
                              (blur)="validatePersonalInfoField('contactLastName', $event)"
                              (ngModelChange)="updatePersonalInformation({ lastName: $event }, 'contactLastName', true)" />
                            <label for="lastNameContactCtrl">Last Name</label>
                            @if (!personalInformationValidations.get('contactLastName')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactLastName')?.()?.error; track
                            $index)
                            {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                        <div class="col mt-4 mb-4">
                          <div class="form-floating">
                            <input placeholder type="email" class="form-control" name="emailContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactEmail')?.()?.valid"
                              [ngModel]="personalInformation()?.contactPerson?.email"
                              (blur)="validatePersonalInfoField('contactEmail', $event)"
                              (ngModelChange)="updatePersonalInformation({ email: $event }, 'contactEmail', true)" />
                            <label for="emailContactCtrl">Email</label>
                            @if (!personalInformationValidations.get('contactEmail')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactEmail')?.()?.error; track $index)
                            {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                        <div class="col mt-4 mb-4">
                          <div class="form-floating">
                            <input placeholder type="text" class="form-control" maxlength="10" appOnlyNumber
                              name="phoneContactCtrl"
                              [class.is-invalid]="!personalInformationValidations.get('contactPhone')?.()?.valid"
                              (blur)="validatePersonalInfoField('contactPhone', $event)"
                              [ngModel]="personalInformation()?.contactPerson?.phone"
                              (ngModelChange)="updatePersonalInformation({ phone: $event }, 'contactPhone', true)" />
                            <label for="phoneContactCtrl">Phone</label>
                            @if (!personalInformationValidations.get('contactPhone')?.()?.valid) {
                            @for (error of personalInformationValidations.get('contactPhone')?.()?.error; track $index)
                            {
                            <div class="invalid-feedback">
                              <i class="fas fa-xmark"></i>
                              {{error}}
                            </div>
                            }
                            }
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div class="row form-row">
                  <div class="col-md-3">
                    <div class="form-floating">
                      <mat-checkbox [checked]="checkboxValues[0]"
                        (change)="updateCheckboxValue($event.checked, 0)">Receive SMS messages</mat-checkbox>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                      <mat-checkbox [checked]="checkboxValues[1]"
                        (change)="updateCheckboxValue($event.checked, 1)">Receive information on our latest product
                        offerings, events and local impact</mat-checkbox>
                    </div>
                  </div>
                </div>
                <div class="form-row-action">
                  <button type="button" class="btn btn-primary"
                    [disabled]="shouldDisableCreateClientButton() || !firstStep.completed" (click)="createNewClient()">
                    Continue
                  </button>
                </div>

              </form>
            </div>
            }
          </mat-step>

          <mat-step #thirdStep [editable]="false" [completed]="false" label="Payment Method">
            <app-payment-method-signup (out_paymentMethod)="paymentMethod.set($event)"
              (out_isValidFormPaymentMethod)="isValidFormPaymentMethod.set($event)" (out_done)="sendDataToANet()">
            </app-payment-method-signup>
          </mat-step>

          <mat-step #fourthStep [editable]="false" [completed]="false" label="Welcome!">
            <app-welcome [products]="signupProducts()"></app-welcome>
          </mat-step>

        </mat-stepper>
      </div>
    </div>
  </div>

  <app-faqs class="animated fadeInUp" [step]="matStepper().selectedIndex"></app-faqs>
  <app-footer class="animated fadeInUp"></app-footer>
</section>